import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = {
  key: 1,
  class: "bg-foreground/50 pointer-events-none absolute inset-0 flex items-center justify-center text-white opacity-0 transition-opacity group-hover:opacity-100"
}

import { type SharedData, type AuthUser } from '@/types';
    import { useForm, usePage, Link, router } from '@inertiajs/vue3';
    import { Button } from '@/components/ui/button';
    import { Input } from '@/components/ui/input';
    import { InputRow } from '@/components/ui/form';
    import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
    import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
    import { useInitials } from '@/composables/useInitials';
    import { Separator } from '@/components/ui/separator';
    import { Select } from '@/components/ui/form';
    import { optionsOnOff } from '@/utils/form';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { computed, onErrorCaptured, ref } from 'vue';
    import { LogOut, Pencil } from 'lucide-vue-next';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileInformationForm',
  props: {
    user: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t, locale } = useI18n({ useScope: 'global' });

    const { getInitials } = useInitials();

    const form = useForm({
        name: props.user.name,
        email: props.user.email,
        phone: props.user.phone,
        language: props.user.language,
        receive_notifications: props.user.receive_notifications,
    });

    const languageOptions = computed(() => [
        { value: 'da', label: t('users.language.da') },
        { value: 'en', label: t('users.language.en') },
    ]);

    const submit = () => {
        form.patch(route('v2.profile.update'), {
            preserveScroll: true,
            onSuccess: () => {
                locale.value = form.language;
                toast.success(t('forms.general.success'));
            },
        });
    };

    const fileInput = ref<HTMLInputElement | null>(null);

    const triggerFileInput = () => {
        fileInput.value?.click();
    };

    const { mutate: uploadProfilePicture, isPending } = useMutation({
        mutationFn: (file: File) => {
            const formData = new FormData();
            formData.append('file', file);
            return axios.post(route('v2.user.profile-picture.upload'), formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        },
        onSuccess: () => {
            router.reload();
        },
        onError: (error: any) => {
            if (error.status === 413) {
                toast.error(t('profile.picture_upload_error'));
            } else {
                toast.error(t('profile.picture_upload_failed'));
            }
        },
    });

    const handleFileChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        if (target.files && target.files[0]) {
            uploadProfilePicture(target.files[0]);
            target.value = '';
        }
    };

    const handleLogout = () => {
        router.flushAll();
        router.post(route('logout'));
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "w-full max-w-lg self-center" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Avatar), {
              class: _normalizeClass([_unref(isPending) && 'opacity-50'])
            }, {
              default: _withCtx(() => [
                (_ctx.user.avatar)
                  ? (_openBlock(), _createBlock(_unref(AvatarImage), {
                      key: 0,
                      src: _ctx.user.avatar,
                      alt: _ctx.user.name
                    }, null, 8, ["src", "alt"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AvatarFallback), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getInitials)(_ctx.user?.name)), 1)
                  ]),
                  _: 1
                }),
                (!_unref(isPending))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createVNode(_unref(Pencil), { class: "size-4" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("input", {
              ref_key: "fileInput",
              ref: fileInput,
              type: "file",
              accept: "image/*",
              class: "hidden",
              onChange: handleFileChange
            }, null, 544),
            _createVNode(_unref(CardTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('profile.your_information')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              variant: "ghost_primary",
              size: "sm",
              width: "narrow",
              class: "ml-auto",
              onClick: handleLogout
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('menu.logout')) + " ", 1),
                _createVNode(_unref(LogOut))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createVNode(_unref(CardContent), { class: "space-y-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "name",
              label: "users.form.name"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "name",
                  modelValue: _unref(form).name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
                  required: "",
                  autocomplete: "name",
                  placeholder: _unref(t)('users.form.name')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "email",
              label: "users.form.email"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "email",
                  type: "email",
                  modelValue: _unref(form).email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).email) = $event)),
                  required: "",
                  autocomplete: "username",
                  placeholder: _unref(t)('users.form.email')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "phone",
              label: "users.form.phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "phone",
                  type: "tel",
                  modelValue: _unref(form).phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).phone) = $event)),
                  autocomplete: "tel",
                  placeholder: _unref(t)('users.form.phone')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(Separator)),
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "language",
              label: "users.form.language"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _unref(form).language,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).language) = $event)),
                  options: languageOptions.value
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "receive_notifications",
              label: "users.form.notifications"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _unref(form).receive_notifications,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).receive_notifications) = $event)),
                  options: _unref(optionsOnOff),
                  translate: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"])
          ]),
          _: 1
        }),
        _createVNode(_unref(CardFooter), { class: "border-t" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              disabled: _unref(form).processing || !_unref(form).isDirty,
              loading: _unref(form).processing
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('forms.save_changes')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}
}

})